import Box from '@mui/material/Box';
import { useTheme } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import {
  Area,
  AreaChart,
  ReferenceLine,
  ResponsiveContainer,
  XAxis,
  YAxis,
} from 'recharts';

import { useColorTokens } from '@/app/themes';

function generateNormalDistribution(mean = 50, stdDev = 10, numPoints = 100) {
  const data = [];

  for (let i = 0; i < numPoints; i++) {
    const x = 10 + (i / numPoints) * 80;
    const exponent = -Math.pow(x - mean, 2) / (2 * Math.pow(stdDev, 2));
    const y = Math.exp(exponent) / (stdDev * Math.sqrt(2 * Math.PI));

    data.push({
      cpm: x,
      auctions: y * 100,
    });
  }

  return data;
}

const data = generateNormalDistribution();
const highBaseCPM = 68; // Red dashed line position

const WinningCpmBellCurve = () => {
  const theme = useTheme();
  const { red } = useColorTokens();

  return (
    <Box maxWidth={420} position='relative'>
      <ResponsiveContainer width='100%' height={220}>
        <AreaChart data={data}>
          <XAxis
            dataKey='cpm'
            label={{
              value: 'Winning CPM',
              style: { fontSize: 14, fill: theme.palette.text.primary },
            }}
            tick={false}
            type='number'
            domain={[5, 95]}
          />
          <YAxis
            label={{
              value: 'Auctions',
              angle: -90,
              style: { fontSize: 14, fill: theme.palette.text.primary },
            }}
            tick={false}
            domain={[-0.09, 4]}
          />

          {/* Normal distribution curve */}
          <Area
            type='monotone'
            dataKey='auctions'
            stroke={theme.palette.primary.main}
            strokeWidth={2}
            fill={theme.palette.primary.light}
            fillOpacity={0.2}
          />

          {/* Red dashed line for high base CPM */}
          <ReferenceLine
            x={highBaseCPM}
            stroke={red[100]}
            strokeWidth={2}
            strokeDasharray='4 4'
          />
        </AreaChart>
      </ResponsiveContainer>

      <Box
        display='inline-block'
        position='absolute'
        top={0}
        right={-110}
        sx={{
          backgroundColor: theme.palette.background.paper,
        }}
        width={200}
        px={1.5}
        py={1.25}
        borderRadius={1}
      >
        <Typography variant='body2'>
          Selecting a high base CPM guarantees hitting a reach goal, but at a
          high cost
        </Typography>
      </Box>
    </Box>
  );
};

export default WinningCpmBellCurve;
